import { createFileRoute } from "@tanstack/react-router";

import ChecklistsPage from "@/components/pages/ChecklistsPage";

type ChecklistsPageParams = {
  tab?: string;
};

export const Route = createFileRoute("/_authenticated/checklists/")({
  validateSearch: (search: Record<string, unknown>): ChecklistsPageParams => ({
    tab: (search.tab as string) || undefined,
  }),
  component: ChecklistsPage,
});
